import React, { useMemo } from "react";
import { Navigate } from "react-router-dom";
import { appRoutes } from "@/constants";
import { privateRoutes } from "@/routes";
import { useCan } from "@/contexts/PermissionContext";
import { useQueryClient } from "@tanstack/react-query";
import type { PermissionsResponse } from "@/types/permissions";

const InitialRedirect: React.FC = () => {
  const { has, hasAll, hasAny } = useCan();

  const queryClient = useQueryClient();
  const queries = queryClient.getQueriesData<PermissionsResponse>({
    predicate: (q) =>
      Array.isArray(q.queryKey) && q.queryKey[0] === "user_permissions",
  });
  const hasPermissionData = queries.some(([, data]) => !!data);

  const getIsAllowed = (path: string): boolean => {
    const match = privateRoutes.find((r) => r.path === path) as any;
    const req = match?.permission;
    if (!req) return true;
    if (req.allOf && req.allOf.length > 0) return hasAll(req.allOf);
    if (req.anyOf && req.anyOf.length > 0) return hasAny(req.anyOf);
    if (req.resource && req.action)
      return has({
        resource: req.resource,
        action: req.action,
        subResource: req.subResource,
      });
    return true;
  };

  const firstAllowedPath = useMemo(() => {
    const ordered = appRoutes.filter((i) => !i.isComing);
    console.log("Checking routes for permissions:", ordered);
    console.log("Has permission data:", hasPermissionData);
    for (const item of ordered) {
      const isAllowed = getIsAllowed(item.path);
      console.log(`Route ${item.path}: allowed = ${isAllowed}`);
      if (isAllowed) return item.path;
    }
    console.warn("No allowed routes found, redirecting to /not-authorized");
    return "/not-authorized";
  }, [has, hasAll, hasAny]);

  if (!hasPermissionData) return null;

  return <Navigate to={firstAllowedPath} replace />;
};

export default InitialRedirect;
